export const ActionSetDrawer = ({ commit, state }) => {
  commit('SET_drawer', state.drawer ? false : true)
}
